import {
  faCircleCheck,
  faFlag,
  faTriangleExclamation
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ThreeDots } from "react-loader-spinner";

import i18n from "../../constants/i18n";
import ET3Div from "../../core/et3-div";
import { withLiteObserverAndTheme } from "../../core/et3-enhanced-render";
import Et3Text from "../../core/et3-text";
import getCoreUIStore from "../../stores/core/core-ui-store";
import {
  ALARM_ACCENT_HEIGHT,
  ALARM_DANGER_CARD_BACKGROUND,
  ALARM_DANGER_CARD_BORDER,
  ALARM_SAFE_STATUS_BACKGROUND,
  ALARM_STATUS_DOT_SIZE,
  ALARM_STATUS_FONT_SIZE,
  ALARM_STATUS_GAP,
  ALARM_STATUS_HEIGHT,
  ALARM_STATUS_LETTER_SPACING,
  ALARM_STATUS_PADDING_X,
  ALARM_STATUS_RADIUS,
  ALARM_ACCENT_RADIUS,
  ALARM_ACCENT_WIDTH,
  ALARM_CARD_BORDER,
  ALARM_CARD_GAP,
  ALARM_CARD_HEIGHT,
  ALARM_CARD_PADDING_X,
  ALARM_CARD_RADIUS,
  ALARM_CARD_SHADOW,
  ALARM_CARD_WIDTH,
  ALARM_DANGER_BADGE,
  ALARM_ICON_BADGE_RADIUS,
  ALARM_ICON_BADGE_SIZE,
  ALARM_ICON_SIZE,
  ALARM_INFO_BADGE,
  ALARM_LABEL_FONT_SIZE,
  ALARM_LOADER_HEIGHT,
  ALARM_LOADER_WIDTH,
  ALARM_SAFE_BADGE,
  ALARM_TEXT_GAP,
  ALARM_VALUE_FONT_SIZE,
  ALARM_WARN_BADGE
} from "./alarm-constants";

const Item = withLiteObserverAndTheme<{
  title: string;
  data: string;
  inDanger: boolean;
}>((props) => {
  const { theme, title, data, inDanger } = props;
  const { colors, unitX, unitY } = theme;
  const isLoading = getCoreUIStore().isLatestDataLoading.get();
  const isApproveReject = title === i18n.get("APPROVE_REJECT");
  const isReports = title === i18n.get("REPORTS");
  const isInvestigation = title === i18n.get("INVESTIGATION_CASES");
  const isDangerStatus = data === i18n.get("DANGER");
  const isSafeStatus = data === i18n.get("SAFE");
  const isStatusCard = isDangerStatus || isSafeStatus;

  const accentColor = (() => {
    switch (true) {
      case inDanger:
        return colors.all.red;
      case isApproveReject:
        return colors.all.bondiBlue;
      case isReports:
        return colors.all.darkOrange;
      default:
        return colors.all.green;
    }
  })();

  const badgeBackground = (() => {
    switch (true) {
      case inDanger:
        return ALARM_DANGER_BADGE;
      case isApproveReject:
        return ALARM_INFO_BADGE;
      case isReports:
        return ALARM_WARN_BADGE;
      default:
        return ALARM_SAFE_BADGE;
    }
  })();

  const badgeIcon = (() => {
    switch (true) {
      case inDanger:
        return faTriangleExclamation;
      case isReports:
        return faFlag;
      default:
        return faCircleCheck;
    }
  })();

  const isCounter = isApproveReject || isReports || isInvestigation;

  return (
    <ET3Div
      isScrollable={false}
      isExtendable={false}
      withShadow={false}
      width={ALARM_CARD_WIDTH}
      height={ALARM_CARD_HEIGHT}
      fDirection={"row"}
      color={inDanger ? ALARM_DANGER_CARD_BACKGROUND : colors.all.white}
      style={{
        boxSizing: "border-box",
        borderRadius: ALARM_CARD_RADIUS * unitX,
        border: inDanger ? ALARM_DANGER_CARD_BORDER : ALARM_CARD_BORDER,
        boxShadow: ALARM_CARD_SHADOW,
        paddingLeft: ALARM_CARD_PADDING_X * unitX,
        paddingRight: ALARM_CARD_PADDING_X * unitX,
        gap: ALARM_CARD_GAP * unitX
      }}
      alignItems="center"
      justifyContent="flex-start"
      onClick={() => {}}
    >
      <ET3Div
        isScrollable={false}
        isExtendable={false}
        withShadow={false}
        width={ALARM_ACCENT_WIDTH}
        height={ALARM_ACCENT_HEIGHT}
        fDirection="row"
        alignItems="center"
        justifyContent="center"
        color={accentColor}
        style={{
          flexShrink: 0,
          borderRadius: ALARM_ACCENT_RADIUS * unitX
        }}
        onClick={() => {}}
      />
      <ET3Div
        isScrollable={false}
        isExtendable={false}
        withShadow={false}
        width={ALARM_ICON_BADGE_SIZE}
        height={ALARM_ICON_BADGE_SIZE}
        fDirection="row"
        alignItems="center"
        justifyContent="center"
        color={badgeBackground}
        style={{
          flexShrink: 0,
          borderRadius: ALARM_ICON_BADGE_RADIUS * unitX
        }}
        onClick={() => {}}
      >
        <FontAwesomeIcon
          icon={badgeIcon}
          color={accentColor}
          style={{
            width: ALARM_ICON_SIZE * unitX,
            height: ALARM_ICON_SIZE * unitY
          }}
        />
      </ET3Div>
      <ET3Div
        isScrollable={false}
        isExtendable={true}
        withShadow={false}
        width={0}
        height={0}
        fDirection={"column"}
        color={colors.all.transparent}
        style={{
          flexGrow: 1,
          minWidth: 0,
          gap: ALARM_TEXT_GAP * unitY
        }}
        alignItems="flex-start"
        justifyContent="center"
        onClick={() => {}}
      >
        <Et3Text
          color={colors.all.maastrichtBlue}
          text={title}
          fontFamily="MEDIUM"
          fontSize={ALARM_LABEL_FONT_SIZE}
          isSpan={false}
          style={{
            margin: 0,
            textAlign: "left",
            wordWrap: "break-word"
          }}
        />
        {isLoading ? (
          <ThreeDots
            color={colors.all.bondiBlue}
            height={ALARM_LOADER_HEIGHT}
            width={ALARM_LOADER_WIDTH}
          />
        ) : isStatusCard ? (
          <ET3Div
            isScrollable={false}
            isExtendable={false}
            withShadow={false}
            width={ALARM_STATUS_HEIGHT}
            height={ALARM_STATUS_HEIGHT}
            fDirection="row"
            alignItems="center"
            justifyContent="center"
            color={
              isDangerStatus ? colors.all.red : ALARM_SAFE_STATUS_BACKGROUND
            }
            style={{
              boxSizing: "border-box",
              width: "auto",
              minWidth: 0,
              height: ALARM_STATUS_HEIGHT * unitY,
              borderRadius: ALARM_STATUS_RADIUS * unitX,
              paddingLeft: ALARM_STATUS_PADDING_X * unitX,
              paddingRight: ALARM_STATUS_PADDING_X * unitX,
              gap: ALARM_STATUS_GAP * unitX
            }}
            onClick={() => {}}
          >
            <ET3Div
              isScrollable={false}
              isExtendable={false}
              withShadow={false}
              width={ALARM_STATUS_DOT_SIZE}
              height={ALARM_STATUS_DOT_SIZE}
              fDirection="row"
              alignItems="center"
              justifyContent="center"
              color={isDangerStatus ? colors.all.white : colors.all.green}
              style={{
                flexShrink: 0,
                borderRadius: ALARM_STATUS_DOT_SIZE * unitX
              }}
              onClick={() => {}}
            />
            <Et3Text
              color={isDangerStatus ? colors.all.white : colors.all.green}
              text={data.toUpperCase()}
              fontFamily="BOLD"
              fontSize={ALARM_STATUS_FONT_SIZE}
              isSpan={false}
              style={{
                margin: 0,
                whiteSpace: "nowrap",
                letterSpacing: ALARM_STATUS_LETTER_SPACING * unitX
              }}
            />
          </ET3Div>
        ) : (
          <Et3Text
            color={
              inDanger
                ? colors.all.red
                : isCounter
                  ? colors.all.maastrichtBlue
                  : accentColor
            }
            text={data}
            fontFamily="BOLD"
            fontSize={ALARM_VALUE_FONT_SIZE}
            isSpan={false}
            style={{ margin: 0, textAlign: "left" }}
          />
        )}
      </ET3Div>
    </ET3Div>
  );
});
export default Item;
